import styled from "styled-components";

export const WalletPubListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 12px;
`;

export const WalletPubListAreaItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
  border-radius: 8px;
  padding: 16px;
  background: var(--Black-100, #f0f0f0);
`;

export const WalletPubListAreaName = styled.div`
  font-weight: 600;
  font-size: 15px;
  color: var(--Black-500, #202020);
`;
